import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

export default withStyles(({ style }) => ({
    tooltip: {
        padding: `12px`,
        backgroundColor: `#484848`,
        ...style
    }
}))(Tooltip);
